import React, {createContext, useCallback, useMemo, useState} from 'react';

// Create a Context for the table
export const TableContext = createContext();

// Create a provider component
export const TableProvider = ({ children }) => {
    const [currentTable, setCurrentTable] = useState(null);

    const selectTable = useCallback((table) => {
        setCurrentTable(table);
    }, []);

    const removeTable = useCallback(() => {
        setCurrentTable(null);
    }, []);

    // Memoize the context value so consumers only re-render when currentTable
    // actually changes, not on every incidental provider re-render. selectTable
    // and removeTable are already useCallback-stable, so the ref stays identical
    // across renders where currentTable is unchanged.
    const value = useMemo(
        () => ({ currentTable, selectTable, removeTable }),
        [currentTable, selectTable, removeTable],
    );

    return (
        <TableContext.Provider value={value}>
            {children}
        </TableContext.Provider>
    );
};